import React, { useState } from 'react'

import Categories from '../categories/Categories'
import CountryFilter from '../countryFilter/CountryFilter'
import BundleCard from './BundleCard'

const RoamingBundles = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [selectedCountries, setSelectedCountries] = useState<string[]>([])

  return (
    <div>
      <CountryFilter
        selectedCountries={selectedCountries}
        setSelectedCountries={setSelectedCountries}
      />
      <Categories selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
      <BundleCard selectedCategory={selectedCategory} selectedCountries={selectedCountries} />
    </div>
  )
}

export default RoamingBundles
